import { createSystem, defaultConfig } from "@chakra-ui/react";

export const system = createSystem(defaultConfig, {
  theme: {
    tokens: {
      fonts: {
        heading: { value: "'Montserrat Variable', sans-serif" },
        body: { value: "'Montserrat Variable', sans-serif" },
        mono: {
          value:
            "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
        },
      },
      colors: {
        primary: {
          50: { value: "#dafffd" },
          100: { value: "#b1fbf5" },
          200: { value: "#85f6ec" },
          300: { value: "#57f1e5" },
          400: { value: "#2ceddd" },
          500: { value: "#12d3c4" },
          600: { value: "#00a498" },
          700: { value: "#00766d" },
          800: { value: "#004741" },
          900: { value: "#001918" },
        },
        secondary: {
          50: { value: "#e3fde9" },
          100: { value: "#bdf3c9" },
          200: { value: "#94e9a7" },
          300: { value: "#6be185" },
          400: { value: "#43d863" },
          500: { value: "#2abe49" },
          600: { value: "#1e9438" },
          700: { value: "#136a27" },
          800: { value: "#073f16" },
          900: { value: "#001702" },
        },
      },
    },
    semanticTokens: {
      colors: {
        primary: {
          solid: { value: "{colors.primary.500}" },
          contrast: { value: "{colors.white}" },
          fg: { value: "{colors.primary.600}" },
          muted: { value: "{colors.primary.300}" },
          subtle: { value: "{colors.primary.50}" },
          emphasized: { value: "{colors.primary.300}" },
          focusRing: { value: "{colors.primary.500}" },
        },
        secondary: {
          solid: { value: "{colors.secondary.500}" },
          contrast: { value: "{colors.white}" },
          fg: { value: "{colors.secondary.600}" },
          muted: { value: "{colors.secondary.300}" },
          subtle: { value: "{colors.secondary.50}" },
          emphasized: { value: "{colors.secondary.300}" },
          focusRing: { value: "{colors.secondary.500}" },
        },
      },
    },
  },
});
